import cn from 'classnames';
import getConfig from 'next/config';
import { useEffect, useState } from 'react';

import { Icon, Space, Typography } from '@sravni/react-design-system';
import { ArrowRight, Wallet } from '@sravni/react-icons';
import { useAnalytics, useIsMobile } from '@sravni/react-utils';

import { getLastUserDeal } from '../../services/marketplace';

import styles from './last-deal.module.scss';

export const LastDeal = ({ userId }: { userId: string }) => {
  const domains = getConfig().publicRuntimeConfig.headerDomains;
  const url = `${domains.marketplace}/cabinet/credit/`;
  const isMobile = useIsMobile();
  const [lastDeal, setLastDeal] = useState();
  const { pushEvent } = useAnalytics();
  const stepText = 'Продолжить оформление';

  useEffect(() => {
    const fetchDeal = async (id) => {
      const data = await getLastUserDeal(id);
      setLastDeal(data);

      if (data?.state === 'created') {
        pushEvent({
          event: 'mainEvent',
          eventCategory: 'Подбор кредита',
          eventAction: 'Показ баннера возврата',
          eventLabel: `Этап воронки - ${stepText}`,
          eventValue: undefined,
        });
      }
    };

    fetchDeal(userId);
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [userId]);

  const handleBannerClick = (e) => {
    e.preventDefault();

    pushEvent({
      event: 'mainEvent',
      eventCategory: 'Подбор кредита',
      eventAction: 'Переход из баннера возврата',
      eventLabel: `Этап воронки - ${stepText}`,
      eventValue: undefined,
    });

    document.location.href = url;
  };

  // @ts-ignore
  if (lastDeal?.state !== 'created') return null;

  return (
    <a href={url} className={cn(styles.deal, { 'h-mt-4': isMobile })} onClick={handleBannerClick}>
      <Space direction={'horizontal'} size={12} align={'center'}>
        <Icon background={'gray'} size={20} shape={'round'}>
          <Wallet className={'h-color-O100'} />
        </Icon>
        <div>
          <Typography.Heading level={5}>Ваша заявка на кредит</Typography.Heading>
          <Typography.Text size={14}>{stepText}</Typography.Text>
        </div>
        <ArrowRight className={cn('h-color-D30', styles.arrow)} />
      </Space>
    </a>
  );
};
